import React, { useEffect, useMemo, useState } from 'react';
import Select from 'react-select';
import { v2_all_user } from '../../actions/v2/user';

const RecordListFilters = ({ value = {}, onChange, showName = true, subjectLabel = 'Subject / Purpose' }) => {
    const [users, setUsers] = useState([]);
    const [isLoadingUsers, setIsLoadingUsers] = useState(false);
    const update = (event) => onChange({ ...value, [event.target.name]: event.target.value });
    const reset = () => onChange({ fromDate: '', toDate: '', userId: '', subject: '' });

    useEffect(() => {
        if (!showName) return undefined;

        let isMounted = true;
        setIsLoadingUsers(true);

        v2_all_user()
            .then((res) => {
                if (!isMounted || !res?.status) return;
                setUsers(Array.isArray(res.result) ? res.result : []);
            })
            .catch(() => {
                if (isMounted) setUsers([]);
            })
            .finally(() => {
                if (isMounted) setIsLoadingUsers(false);
            });

        return () => {
            isMounted = false;
        };
    }, [showName]);

    const userOptions = useMemo(() => users
        .filter((user) => user?.USER_ID && user?.FULL_NAME)
        .map((user) => ({
            value: String(user.USER_ID),
            label: user.FULL_NAME,
        }))
        .sort((first, second) => first.label.localeCompare(second.label)), [users]);

    const selectedUser = userOptions.find((user) => user.value === String(value.userId || '')) || null;
    const updateUser = (user) => onChange({ ...value, userId: user?.value || '' });
    const hasActiveFilters = Boolean(value.fromDate || value.toDate || value.name || value.userId || value.subject);

    return (
        <div className="card mb-3">
            <div className="card-body py-3">
                <div className="row g-2 align-items-end">
                    <div className="col-md-3">
                        <label className="form-label mb-1">From date</label>
                        <input type="date" className="form-control" name="fromDate" value={value.fromDate || ''} onChange={update} />
                    </div>
                    <div className="col-md-3">
                        <label className="form-label mb-1">To date</label>
                        <input type="date" className="form-control" name="toDate" value={value.toDate || ''} onChange={update} />
                    </div>
                    {showName && <div className="col-md-3">
                        <label className="form-label mb-1">User</label>
                        <Select
                            classNamePrefix="record-list-user"
                            options={userOptions}
                            value={selectedUser}
                            onChange={updateUser}
                            isClearable
                            isLoading={isLoadingUsers}
                            placeholder="Search and select a user"
                            noOptionsMessage={() => 'No users found'}
                        />
                    </div>}
                    <div className={showName ? 'col-md-2' : 'col-md-5'}>
                        <label className="form-label mb-1">{subjectLabel}</label>
                        <input type="search" className="form-control" name="subject" placeholder={`Search ${subjectLabel.toLowerCase()}`} value={value.subject || ''} onChange={update} />
                    </div>
                    <div className="col-md-1">
                        <button type="button" className="btn btn-light w-100" onClick={reset} title="Clear filters">
                            <i className="bx bx-reset" />
                        </button>
                    </div>
                </div>
                {hasActiveFilters && <div className="mt-3">
                    <button type="button" className="btn btn-outline-secondary btn-sm" onClick={reset}>
                        <i className="bx bx-arrow-back me-1" /> Back to main list
                    </button>
                </div>}
            </div>
        </div>
    );
};

export default RecordListFilters;
